import {BaseEntity, Required} from "../common/base-entity";
import {Telephone} from "../shared/telephone";
import {ReferredClient} from "./referred-client";
import {Address} from "../shared/address";
import {ReferralDocument} from "./referral-document";
import {TelephoneTypes} from "../shared/telephone-types";
import {AddressTypes} from "../shared/address-types";
import {Validators} from "@angular/forms";
import {FormArray, FormControl, FormGroup} from "rx-form-mapper";


export class ReferralForm extends BaseEntity {

    id: number;
    // Submitter
    @FormControl()
    referringAgentFirstName: string;
    @FormControl()
    referringAgentMiddleName: string;
    @FormControl()
    referringAgentLastName: string;
    @FormControl()
    referringAgentRole: string;
    @FormArray(Telephone)
    referringAgentTelephones: Telephone[] = [];
    @FormControl()
    referringAgentEmail: string;
    @FormControl()
    referringAgentCompany: string;

    // Parties
    @FormArray(ReferredClient)
    referredClients: ReferredClient[] = [];

    // Transaction
    @FormControl()
    closingDate: string;
    @FormGroup()
    propertyAddress: Address;
    @FormControl()
    transactionType: string;
    @FormControl()
    purchaseType: string;
    @FormControl()
    purchasePrice: number;
    @FormControl()
    depositAmount: number;
    @FormControl()
    otherSolicitorId: number;
    @FormControl()
    otherSolicitorName: string;
    @FormControl()
    otherLawFirmId: number;
    @FormControl()
    otherLawFirmName: string;
    @FormControl()
    realEstateAgentName: string;
    @FormControl()
    realEstateBrokerageFirmId: number;
    @FormControl()
    realEstateBrokerageFirmName: string;
    @FormControl()
    totalCommissionAmount: number;
    @FormControl()
    newMortgageAmount: number;
    @FormControl()
    referralNotes: string;
    @FormControl()
    mortgageNotes: string;
    //Receving
    @FormControl()
    receivingSolicitorId: number;
    @FormControl()
    receivingSolicitorName: string;
    @FormControl()
    receivingSolicitorAddress: string;
    @FormControl()
    receivingLawFirmId: number;
    @FormControl()
    receivingLawFirmName: string;
    @FormControl()
    submissionDate: number;

    constructor(referral?: ReferralForm) {
        super(referral);
        if (referral) {
            this.referringAgentTelephones = [];
            if (referral.referringAgentTelephones) {
                this.populatePhones(referral, [TelephoneTypes.home, TelephoneTypes.cell, TelephoneTypes.work]);
            }
            if (referral.propertyAddress) {
                referral.propertyAddress = new Address(referral.propertyAddress);
            }
            this.referredClients = [];
            if (Array.isArray(referral.referredClients)) {
                for (let cc of referral.referredClients) {
                    this.referredClients.push(new ReferredClient(cc));
                }
            }

        }

        if(!this.transactionType){
            this.transactionType  = 'PURCHASE';
        }

        if (!this.referringAgentTelephones || this.referringAgentTelephones.length == 0) {
            this.referringAgentTelephones = [];
            this.initializePhones([TelephoneTypes.home, TelephoneTypes.cell, TelephoneTypes.work]);
        }
        if (!this.propertyAddress) {
            this.propertyAddress = new Address();
            this.propertyAddress.addressTypeCode = AddressTypes.subjectAddress;
        } else if (!(this.propertyAddress instanceof Address)) { // for that case when loading ReferralForm from JSON and propertyAddress is loaded without a type and attached methods are not working
            this.propertyAddress = new Address(this.propertyAddress);
        }


    }

    populatePhones(referral: ReferralForm, phoneTypes: string[]): void {
        for (const phoneType of phoneTypes) {
            let phone: Telephone = referral.referringAgentTelephones.find((t: Telephone) => t.phoneTypeCode === phoneType);
            if (phone) {
                this.referringAgentTelephones.push(new Telephone(phone));
            } else {
                phone = new Telephone();
                phone.phoneTypeCode = phoneType;
                this.referringAgentTelephones.push(phone);
            }
        }
    }

    initializePhones(phoneTypes: string[]): void {
        for (let phoneType of phoneTypes) {
            let phone: Telephone = this.referringAgentTelephones.find((t: Telephone) => t.phoneTypeCode === phoneType);

            if (!phone) {
                phone = new Telephone();

                phone.phoneTypeCode = phoneType;

                this.referringAgentTelephones.push(phone);
            }
        }
    }


}
